import { z } from 'zod';

export const LOCAL_RECORDING_PLAYBACK_PATH = '/macro-editor/recording-playback';
export const localRecordingPlaybackCommandSchema = z.discriminatedUnion('command', [
  z.object({ command: z.literal('prepare'), packageId: z.string().uuid() }).strict(),
  z.object({ command: z.literal('play'), playbackId: z.string().uuid() }).strict(),
  z.object({ command: z.literal('pause'), playbackId: z.string().uuid() }).strict(),
  z.object({ command: z.literal('stop'), playbackId: z.string().uuid() }).strict(),
  z.object({ command: z.literal('status'), playbackId: z.string().uuid() }).strict(),
  z.object({ command: z.literal('seek'), playbackId: z.string().uuid(), seconds: z.number().finite().nonnegative() }).strict(),
  z.object({ command: z.literal('rate'), playbackId: z.string().uuid(), rate: z.number().finite().min(0.1).max(16) }).strict(),
]);
export const localRecordingMediaStateSchema = z.object({
  paused: z.boolean(), ended: z.boolean(), currentTime: z.number().finite().nonnegative(),
  duration: z.number().finite().positive(), playbackRate: z.number().finite().positive(),
}).strict();
export const localRecordingPlaybackSourceSchema = z.object({
  kind: z.literal('display'), id: z.string().min(1), label: z.string(), displayId: z.number().int().nonnegative(),
  gdiDeviceName: z.string().min(1), width: z.number().int().positive(), height: z.number().int().positive(),
  x: z.number().int(), y: z.number().int(), isPrimary: z.boolean().optional(),
}).strict();
export const localRecordingPlaybackSnapshotSchema = z.object({
  version: z.literal(1), playbackId: z.string().uuid().nullable(), packageId: z.string().uuid().nullable(), windowId: z.number().int().positive().nullable(),
  source: localRecordingPlaybackSourceSchema.nullable(), media: localRecordingMediaStateSchema.nullable(),
}).strict();
export type LocalRecordingPlaybackCommand = z.infer<typeof localRecordingPlaybackCommandSchema>;
export type LocalRecordingMediaState = z.infer<typeof localRecordingMediaStateSchema>;
export type LocalRecordingPlaybackSnapshot = z.infer<typeof localRecordingPlaybackSnapshotSchema>;
